import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrestataireCardLike from "../PrestataireCardLike";
import ProjectCard from "../ProjectCard";
import { fetchLikesReceived, sendLike } from "../../redux/actions/likeActions";
import ModalInfo from "../ModalInfo";
import { setActiveSection } from "../../redux/actions/dashboardActions";

const LikesReceivedDashboard = () => {
    const dispatch = useDispatch();
    const { token, user } = useSelector((state) => state.auth || {});
    const receivedLikes = useSelector((state) => state.like.received || []);
    const { activeSubscription } = useSelector((state) => state.subscriptionOffer);

    const [selectedLike, setSelectedLike] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    useEffect(() => {
        if (token) {
          dispatch(fetchLikesReceived(token));
        }
      }, [dispatch, token]);
    
    const containerStyle = {
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
    };

    const listCard = {
        padding: "15px",
        border: "1px solid #ddd",
        borderRadius: "10px",
        background: "#fff",
        cursor: "pointer",
        transition: "0.25s",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    };

    const applyHover = (e) => {
        e.currentTarget.style.borderColor = "#4A6CF7";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
    };

    const removeHover = (e) => {
        e.currentTarget.style.borderColor = "#ddd";
        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.05)";
    };
    const handleLike = () => {
        if (!token || !selectedLike) return;

        if (user.rolesUser[0].roleUser === "prestataire") {
            if (activeSubscription) {
                dispatch(sendLike(selectedLike.projet.idProjetClient, null, token));
                dispatch(fetchLikesReceived(token));
            } else {
                setShowModalInfo(true);
            }
        } else {
            dispatch(
                sendLike(
                    selectedLike.projet.idProjetClient,
                    selectedLike.prestataire?.profilPrestataire.idPrestataire,
                    token
                )
            );
            dispatch(fetchLikesReceived(receivedLikes));
        }

        setShowDetails(false);
    };

    const handlePass = () => {
        setShowDetails(false);
    };

    // === Vue détaillée
    if (showDetails && selectedLike) {
        return user.rolesUser[0].roleUser === "prestataire" ? (
            <ProjectCard
                project={selectedLike.projet}
                idUserClient={selectedLike.client.idUser}
                onLike={handleLike}
                onPass={handlePass}
                isReceivedLike={true}
            />
        ) : (
            <PrestataireCardLike
                prestataire={selectedLike.prestataire.profilPrestataire}
                projet={selectedLike.projet}
                apiUrl={process.env.REACT_APP_API_URL}
                onLike={handleLike}
                onPass={handlePass}
                isReceivedLike={true}
            />
        );
    }

    if (showModalInfo) {
        return (
            <ModalInfo
                message="Vous devez souscrire à une des offres disponibles pour pouvoir confirmer le match."
                txtBtnCancel="OK"
                txtBtnValid="VOIR LES OFFRES"
                onValid={() => {
                    dispatch(setActiveSection("offres"));
                    setShowModalInfo(false);
                }}
                onCancel={() => setShowModalInfo(false)}
            />
        );
    }

    return (
        <div style={containerStyle}>
            <h2 style={{textAlign:"center"}}>Demandes reçues</h2>
            {receivedLikes.length === 0 ? (
                <p style={{textAlign:"center"}}>Aucune demande reçue pour le moment</p>
            ) : (
                <div>
                    {receivedLikes.map((like) => (
                        <div key={like.idLike}
                            style={listCard}
                            onMouseEnter={applyHover}
                            onMouseLeave={removeHover}
                            onClick={() => {
                                setSelectedLike(like);
                                setShowDetails(true);
                            }}>
                            {user.rolesUser[0].roleUser === "prestataire" ? (
                                <h3>{like.projet?.titreProjetClient}</h3>
                            ) : (
                                <h3>
                                    {like.prestataire?.profilPrestataire.firstNamePrestataire}{" "}
                                    {like.prestataire?.profilPrestataire.lastNamePrestataire}
                                </h3>
                            )}

                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LikesReceivedDashboard;
